import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import marker from '../../assets/marker.png';

const StyledMap = styled.div`
  width: inherit;
  height: inherit;
`;

type MapProps = {
  center: google.maps.LatLngLiteral;
  zoom: number;
};

export const MyDealerMap = (props: MapProps) => {
  const { center, zoom } = props;
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<google.maps.Map>();

  const mapOptions: google.maps.MapOptions = {
    center,
    zoom,
    streetViewControl: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    fullscreenControl: false,
  };

  useEffect(() => {
    if (window.google && window.google.maps && mapRef.current) {
      mapInstanceRef.current = new window.google.maps.Map(mapRef.current, mapOptions);
      new window.google.maps.Marker({
        map: mapInstanceRef.current,
        position: center,
        icon: marker,
      });
    }
  });

  return <StyledMap ref={mapRef} id="myDealerMap" data-testid="myDealer-mapContainer" />;
};
